// src/pages/Team.jsx
import React from "react";
import { Admininstrationdata, teamData } from "../pages/teamdata";


import bhargavaImg from "../assets/images/therapist/bhargava.jpeg";
import sruthiImg from "../assets/images/therapist/sruthi.jpeg";
import { Helmet } from "react-helmet-async";

const teamMembers = [
  {
    img: bhargavaImg,
    name: "DR. SKN BHARGAVA",
    role: "MANAGING DIRECTOR",
     role1: "Ortho & Sports Physiotherapist",
    delay: "0s",
    socials: [
      { platform: "instagram", url: "https://www.instagram.com/brightlife_physiopoint/", iconClass: "fab fa-instagram" },
      { platform: "linkedin", url: "http://linkedin.com/in/dr-bhargava-skn-31b96944/", iconClass: "fab fa-linkedin-in" },
    ],
  },
  {
    img: sruthiImg,
    name: "DR. Vishwa Sruthi",
    role: "CEO",
     role1: "Neuro Physiotherapist",
    delay: "0.25s",
    socials: [
      { platform: "instagram", url: "https://www.instagram.com/brightlife_physiopoint/", iconClass: "fab fa-instagram" },
      { platform: "linkedin", url: "https://www.linkedin.com/in/vishwa-sruthi-a181113a5/", iconClass: "fab fa-linkedin-in" },
    ],
  },
];
export default function Therapists() {


  return (
    <div>
        <Helmet>
  <title>Our Therapists | BrightLife Physio Point Hyderabad</title>
  <meta
    name="description"
    content="Meet our experienced physiotherapists, chiropractors and rehab specialists at BrightLife Physio Point."
  />
</Helmet>
      {/* Page Header (matching your template) */}
      <div className="page-header">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-2" data-cursor="-opaque">
                  Our Therapists
                </h1>
                <nav className="wow fadeInUp">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="/">home</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      our therapists
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Team grid */}
      <div className="page-team">
        <div className="container">
          <div className="team-wrapper">
            {/* LEFT: Team Members */}
            <div className="team-left">
              {teamMembers.map((member, index) => (
                <div
                  className="team-member-item wow fadeInUp"
                  data-wow-delay={member.delay}
                  key={index}
                >
                  <div className="team-image">
                    <figure className="image-anime">
                      <img loading="lazy" src={member.img} alt={member.name} />
                    </figure>
                    {/* Socials */}
                    <div className="team-social-icon">
                      <ul>
                        {member.socials.map((s, idx) => (
                          <li key={idx}>
                            <a
                              href={s.url}
                              target="_blank"
                              className="social-icon"
                              aria-label={s.platform}
                            >
                              <i className={s.iconClass} />
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className="team-content">
                    <h3>{member.name}</h3>
                    <p>{member.role}</p>
                     <p>{member.role1}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* RIGHT: Info Block */}
            <div className="team-right">
              <h3 className="right-title">Why Choose Our Team?</h3>
              <p className="right-text">
                Our therapists bring over{" "}
                <strong>15+ years of combined experience</strong> in
                Physiotherapy, Sports Rehab, Osteopathy &amp; Advanced Manual
                Techniques.
              </p>

              <ul className="right-list">
                <li>✔ Internationally certified specialists</li>
                <li>✔ Evidence-based treatment approach</li>
                <li>✔ Personalized recovery programs</li>
                <li>✔ 1000+ patients successfully treated</li>
              </ul>
            </div>
          </div>

          <div className="section-title">
            <h2 className="text-anime-style-2">
              <span>Our Dedicated</span> Team
            </h2>
          </div>
          <div className="row">
            {teamData.map((member) => (
              <div className="col-lg-3 col-md-6" key={member.id}>
                <div
                  className="team-member-item wow fadeInUp"
                  data-wow-delay={member.delay}
                >
                  {/* Team Image */}
                  <div className="team-image">
                    <figure className="image-anime">
                      <img loading="lazy" src={member.img} alt={member.name} />
                    </figure>

                    {/* Socials */}
                    {/* <div className="team-social-icon">
                      <ul>
                        {member.socials.map((s, idx) => (
                          <li key={idx}>
                            <a
                              href={s.url}
                              className="social-icon"
                              aria-label={s.platform}
                            >
                              <i className={s.iconClass} />
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div> */}
                  </div>

                  {/* Team Content */}
                  <div className="team-content">
                    <h3>{member.name}</h3>
                    <p>{member.title}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>


  <div className="section-title">
            <h2 className="text-anime-style-2">
              <span>Admininstration</span> Team
            </h2>
          </div>
          <div className="row">
            {Admininstrationdata.map((member) => (
              <div className="col-lg-3 col-md-6" key={member.id}>
                <div
                  className="team-member-item wow fadeInUp"
                  data-wow-delay={member.delay}
                >
                  {/* Team Image */}
                  <div className="team-image">
                    <figure className="image-anime">
                      <img loading="lazy" src={member.img} alt={member.name} />
                    </figure>

                    {/* Socials */}
                    {/* <div className="team-social-icon">
                      <ul>
                        {member.socials.map((s, idx) => (
                          <li key={idx}>
                            <a
                              href={s.url}
                              className="social-icon"
                              aria-label={s.platform}
                            >
                              <i className={s.iconClass} />
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div> */}
                  </div>

                  {/* Team Content */}
                  <div className="team-content">
                    <h3>{member.name}</h3>
                    <p>{member.title}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>



        </div>
      </div>
    </div>
  );
}
